import enVehicle from '@hero/lang/locales/en/m-vehicle.json';
import arVehicle from '@hero/lang/locales/ar/m-vehicle.json';
import urVehicle from '@hero/lang/locales/ur/m-vehicle.json';
import type { Language, VehicleTypes } from '@hero/schema';

const TYPES: Record<Language, Record<string, string | undefined>> = {
  en: enVehicle.types,
  ar: arVehicle.types,
  ur: urVehicle.types,
};

/**
 * A vehicle type's user-facing name in one language.
 *
 * The enum is what every tool and API accepts; nobody outside the code
 * calls a truck a `truck_flatbed`. Anywhere the value is shown to a
 * person — a WhatsApp confirmation card, a chat summary — it has to come
 * through here, or an Arabic thread ends up reading "truck flatbed"
 * because the only formatting applied was underscores to spaces.
 *
 * Names come from `@hero/lang`'s `m-vehicle.json`, the same source the
 * dashboard and the mobile apps render from and the same table the
 * agent's glossary teaches the model to map free text onto — so the name
 * the user is shown is the name they were offered.
 */
export const localizeVehicleType = (
  type: VehicleTypes | string,
  language: Language,
): string => {
  const table = TYPES[language] ?? TYPES.en;
  return table[type] ?? TYPES.en[type] ?? String(type).replace(/_/g, ' ');
};
